(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.datejs = factory());
}(this, (function () { 'use strict';

    var DateJS = /** @class */ (function () {
        function DateJS(date) {
            this.date = new Date(date);
        }
        /**
         * 小于 10 的填充 0 补位
         * @param {number} n
         * @returns {string}
         */
        DateJS.prototype._paddingZero = function (num) {
            return ("" + num).padStart(2, '0');
        };
        /**
         * 格式化时间
         * @param {string} formatter yyyy-MM-dd HH:mm:ss
         * @returns {string} 2021-07-19 00:23:44
         */
        DateJS.prototype.format = function (formatter) {
            if (formatter === void 0) { formatter = 'yyyy-MM-dd HH:mm:ss'; }
            var day = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            var obj = {
                'y+': this.date.getFullYear(),
                'M{2}': this._paddingZero(this.date.getMonth() + 1),
                'd{2}': this._paddingZero(this.date.getDate()),
                'H{2}': this._paddingZero(this.date.getHours()),
                'h{2}': this._paddingZero(this.date.getHours() % 12),
                'm{2}': this._paddingZero(this.date.getMinutes()),
                's{2}': this._paddingZero(this.date.getSeconds()),
                'M': this.date.getMonth() + 1,
                'd': this.date.getDate(),
                'H': this.date.getHours(),
                'h': this.date.getHours() % 12,
                'm': this.date.getMinutes(),
                's': this.date.getSeconds(),
                'CW': day[this.date.getDay()],
                'W': this.date.getDay()
            };
            for (var _i = 0, _a = Object.entries(obj); _i < _a.length; _i++) {
                var _b = _a[_i], key = _b[0], value = _b[1];
                var regexp = new RegExp("(" + key + ")([^a-zA-Z])?");
                if (regexp.test(formatter)) {
                    formatter = formatter.replace(RegExp.$1, "" + value);
                }
            }
            return formatter;
        };
        return DateJS;
    }());
    var index = (function (date) { return new DateJS(date || Date.now()); });

    return index;

})));
